import React from 'react';
import { EmptyStateStyle } from "./style";
var EmptyState = function EmptyState() {
  return /*#__PURE__*/React.createElement("div", {
    "walkme-id": "applications-requirements"
  }, /*#__PURE__*/React.createElement(EmptyStateStyle, null, "There are no active requirements to display because this application has been cancelled, withdrawn, or modified by one of the Customer Experience Coordinators. If you want further information or assistance, please leave us a note. One of our Customer Experience Coordinators will assist with your request."));
};
export default EmptyState;